import '../App.css';
import { Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Axios from 'axios';
import React, {useEffect, useState} from 'react';

function Bodyactivate(props)
{
    const [mail, setMail] = useState('');
    const [code1, setCode1] = useState('');
    const [code2, setCode2] = useState('');
    const [code3, setCode3] = useState('');
    const [code4, setCode4] = useState('');
    const [completecode, setCompleteCode] = useState('');
    const [alertHead, setAlertHead] = useState('');
    const [alertBody, setAlertBody] = useState('');
    const [alertClass, setAlertClass] = useState('');
    const [alertActivate, setAlertActivate] = useState(false);


    const navigate = useNavigate();

    useEffect(() => {
        setMail(props.mailRegister)
    }, []);

    const setChangeCode1 = (e)=> 
    {
        setCode1(e.target.value)
    }

    const setChangeCode2 = (e) => 
    {
        setCode2(e.target.value)
    }

    const setChangeCode3 = (e) => 
    {
        setCode3(e.target.value)
    }

    const setChangeCode4 = (e) => 
    {
        setCode4(e.target.value)
    }    

    const activate = async (e) =>
    {
       let statuscall = '' 
       const data = {
            verification_code: code1 + code2 + code3 + code4,
            mail: mail,
            user_state_id: '2'
        };
        
        const userActivate = await Axios.post(process.env.REACT_APP_URLACTIVATE, data, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }           
       }).then(res => statuscall = res ).catch(err => console.log(err));
       
       console.log(statuscall)
       if(statuscall.status == 200)
       {
           if(statuscall.data.MessageCode == "0")
           {
                setAlertHead('Activación de cuenta')
                setAlertBody('Su cuenta ha sido activada. Será redirigido a la página para iniciar sesion. Muchas Gracias.')
                setAlertClass('success')
                setAlertActivate(true)
                setTimeout(() => {
                    setAlertActivate(false)
                    navigate('/')
                }, 7000)
           }
           else
           {
                setAlertHead('Activación de cuenta')
                setAlertBody(statuscall.data.Message)
                setAlertClass('danger')
                setAlertActivate(true)
                setTimeout(() => {
                    setAlertActivate(false)
                }, 4000)
           }   
       }
       else{
            setAlertHead('Activación de cuenta')
            setAlertBody('Su cuenta no se ha podido activar. Contactese con el administrador.')
            setAlertClass('danger')
            setAlertActivate(true)
            setTimeout(() => {
                setAlertActivate(false)
            }, 4000)           
       }
    }

    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerLoginCarrusel'>
            {alertActivate 
                ?<Alert variant={alertClass} onClose={() => setAlertActivate(false)} dismissible>
                <Alert.Heading>{alertHead}</Alert.Heading>
                <p>
                    {alertBody}
                </p>
              </Alert>
              : ''
            }
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>
                    <div className='row'>
                        <div className='col col-lg-5'></div>
                        <div className='col col-lg-2'>
                            <h1>ACTIVAR CUENTA</h1>
                        </div>
                        <div className='col col-lg-5'></div>
                    </div>
                    <div className='row'>
                        <div className='col col-lg-4'>
                        </div>
                        <div className='col col-lg-1'>
                            <div className="col-xs-1">
                                <div className='input-group input-group-lg'>
                                      <input type="text" className="form-control"  onChange={setChangeCode1} placeholder="0" maxLength={1}/>
                                </div>
                            </div>
                        </div>
                        <div className='col col-lg-1'>
                            <div className="col-xs-1">
                                <div className='input-group input-group-lg'>
                                      <input type="text" className="form-control" onChange={setChangeCode2} placeholder="0" maxLength={1}/>
                                </div>
                            </div>
                        </div>
                        <div className='col col-lg-1'>
                            <div className="col-xs-1">
                                <div className='input-group input-group-lg'>
                                      <input type="text" className="form-control" onChange={setChangeCode3} placeholder="0" maxLength={1}/>
                                </div>
                            </div>
                        </div>
                        <div className='col col-lg-1'>
                            <div className="col-xs-1">
                                <div className='input-group input-group-lg'>
                                      <input type="text" className="form-control" onChange={setChangeCode4} placeholder="0" maxLength={1}/>
                                </div>
                            </div>
                        </div>                                                                                    
                        <div className='col col-lg-4'>
                        </div>
                    </div>                             
                    <div className='row'>
                        <div className='col col-lg-4'></div>
                        <div className='col col-lg-4'>
                            <div className="d-grid gap-2">
                                <Button variant="primary" onClick={activate} size="lg">
                                    Activar
                                </Button>
                            </div>
                        </div>
                        <div className='col col-lg-4'></div>
                    </div>                                
                </div>
            </div>
        </div>            
    )    
}
export default Bodyactivate
